import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import DateField from 'containers/components/Fields/Date';
import { normalizeLineDateValue } from 'utils/fm/fields';

/**
 * Table cell adapter for extra-field date columns.
 * Keeps the CustomCell contract (value + onChange) while using EntityCrud DateField.
 */
const ProductLineDateCell = memo(({ value, onChange, isEnriched = false }) => {
    const dateValue = useMemo(() => normalizeLineDateValue(value), [value]);

    const handleChange = useCallback(
        (newDate) => {
            onChange?.(normalizeLineDateValue(newDate));
        },
        [onChange],
    );

    return (
        <DateField
            className="fm-product-line-date-cell"
            value={dateValue}
            onChange={handleChange}
            isEnriched={isEnriched}
        />
    );
});

ProductLineDateCell.displayName = 'ProductLineDateCell';
ProductLineDateCell.propTypes = {
    isEnriched: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
};

export default ProductLineDateCell;
